import React, { useMemo, useState } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { handleGetRequest } from "../../services/GetTemplate";
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../services/PostTemplate";
import { toast } from "react-toastify";
import AddCustomerDialog from "./AddCustomerDialog";
import { Dialog } from "primereact/dialog";
import { useLocation } from "react-router-dom";
import SofStop from "../../modals/SofStop";
import { Tooltip } from "react-tippy";
import ClipLoader from "react-spinners/ClipLoader";
import styles from "./customers.module.scss";
import * as XLSX from "xlsx";

const ROLE_OPTIONS = ["client", "courier", "corporate", "reseller"];
const STAFF_ROLES = ["clerk", "admin", "handler", "airportStaff", "driver"];

function Customers() {
    const role = localStorage.getItem("role");
    const isClerk = role === "clerk";
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get("type");
    const [selectedRow, setselectedRow] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [brands, setBrands] = useState([]);
    const [skip, setSkip] = useState(0);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const breadItems = [{ label: "Home", url: "/" }, { label: "Customers" }];
    const home = { icon: "pi pi-home", url: "/" };
    const history = useHistory();

    const getBrands = async () => {
        setLoading(true);
        if (type) {
            const res = await handleGetRequest(`/searchUsers?role=${type}`);
            setBrands((res?.data || []).filter((user) => !STAFF_ROLES.includes(user.role)));
            setLoading(false);
        } else {
            const res = await handleGetRequest("/allUsers");
            setBrands((res?.data || []).filter((user) => !STAFF_ROLES.includes(user.role)));
            setLoading(false);
        }
    };
    useMemo(() => {
        getBrands();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skip]);

    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-ellipsis-v" className="p-button-rounded mr-2 Elipse_Icon" onClick={(e) => handleActionButton(e, rowData)} aria-controls="popup_menu" aria-haspopup />
            </div>
        );
    };
    const handleActionButton = (e, rowdata) => {
        e.preventDefault();
        history.push(`customer/${rowdata?._id}`);
    };

    const onHideTyreBrandsDialog = () => {
        setShowDialog(false);
    };
    const handledDelete = async () => {
        setShowSoftStop(true);
    };

    const emptyFilters = { search: "", role: "" };
    const [filters, setFilters] = useState(emptyFilters);

    const filteredBrands = useMemo(() => {
        const search = filters.search.trim().toLowerCase();
        return (brands || []).filter((user) => {
            const matchesSearch =
                !search ||
                [user.firstName, user.lastName, user.email, user.phone].some((field) => field?.toLowerCase().includes(search));
            const matchesRole = !filters.role || user.role === filters.role;
            return matchesSearch && matchesRole;
        });
    }, [brands, filters]);

    const handleFilterChange = (field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value }));
    };

    const clearFilters = () => {
        setFilters(emptyFilters);
    };

    const onsuccess = () => {
        onHideTyreBrandsDialog();
        toast.success("customer added");
        window.location.reload();
    };

    const [showSoftStop, setShowSoftStop] = useState(false);

    const onHideSoftStop = () => {
        setShowSoftStop(false);
    };

    const onSuccessSoftStop = async () => {
        setShowSoftStop(false);
        if (selectedRow?.length > 0) {
            const selectedIds = selectedRow.map((val) => val?._id);
            const data = { id: selectedIds };
            const res = await dispatch(handlePostRequest(data, "/deleteUser", true, true));
            if (res?.success) {
                getBrands();
                toast.success("customer deleted");
                window.location.reload();
            }
        }
    };

    const exportToExcel = () => {
        const exportData = brands.map((user) => ({
            firstName: user.firstName || "",
            lastName: user.lastName || "",
            email: user.email || "",
            phoneNumber: user.phone || "",
        }));
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");
        XLSX.writeFile(workbook, "customers.xlsx");
    };

    const totalCount = brands?.length || 0;
    const clientCount = brands?.filter((b) => b.role === "client").length || 0;
    const courierCount = brands?.filter((b) => b.role === "courier").length || 0;

    return (
        <div className={styles.customersPage}>
            <Dialog visible={showDialog} header="Customers" style={{ width: "650px" }} onHide={() => setShowDialog(false)}>
                <AddCustomerDialog onHideTyreBrandsDialog={onHideTyreBrandsDialog} onsuccess={onsuccess} />
            </Dialog>
            <Dialog visible={showSoftStop} style={{ width: "650px" }} onHide={() => setShowSoftStop(false)}>
                <SofStop onHideSoftStop={onHideSoftStop} onSuccessSoftStop={onSuccessSoftStop} type="user"></SofStop>
            </Dialog>

            <div className={styles.pageHeader}>
                <div>
                    <h2>Customers</h2>
                    <BreadCrumb model={breadItems} home={home} />
                    {isClerk && <p style={{ marginTop: "4px" }}>View only mode</p>}
                </div>
                <div className={styles.headerActions}>
                    {!isClerk && (
                        <>
                            <Tooltip title="Add new customer" position="bottom" trigger="mouseenter" arrow={true}>
                                <Button icon="pi pi-plus" label="Add Customer" iconPos="right" onClick={() => setShowDialog(true)} className={styles.addButton} />
                            </Tooltip>
                            <Tooltip title="Delete selected customers" position="bottom" trigger="mouseenter" arrow={true}>
                                <Button icon="pi pi-trash" label="Delete" iconPos="right" onClick={handledDelete} className={styles.deleteButton} />
                            </Tooltip>
                        </>
                    )}
                    <Tooltip title="Export to Excel" position="bottom" trigger="mouseenter" arrow={true}>
                        <Button icon="pi pi-file-excel" label="Export" iconPos="right" onClick={exportToExcel} className={styles.exportButton} />
                    </Tooltip>
                </div>
            </div>

            <div className={styles.statsRow}>
                <div className={styles.statCard}>
                    <div className={styles.statValue}>{totalCount}</div>
                    <div className={styles.statLabel}>Total</div>
                </div>
                <div className={styles.statCard}>
                    <div className={styles.statValue}>{clientCount}</div>
                    <div className={styles.statLabel}>Clients</div>
                </div>
                <div className={styles.statCard}>
                    <div className={styles.statValue}>{courierCount}</div>
                    <div className={styles.statLabel}>Couriers</div>
                </div>
            </div>

            <div className={styles.filtersSection}>
                <div className={styles.filterGroup}>
                    <label>Search</label>
                    <input className={styles.searchInput} placeholder="Search by name, email or phone..." value={filters.search} onChange={(e) => handleFilterChange("search", e.target.value)} />
                </div>
                <div className={styles.filterGroup}>
                    <label>Role</label>
                    <select className={styles.dropdown} value={filters.role} onChange={(e) => handleFilterChange("role", e.target.value)}>
                        <option value="">All Roles</option>
                        {ROLE_OPTIONS.map((r) => (
                            <option key={r} value={r}>
                                {r}
                            </option>
                        ))}
                    </select>
                </div>
                <Button label="Clear" icon="pi pi-times" className={styles.clearButton} onClick={clearFilters} />
            </div>

            <div className={styles.tableContainer}>
                <DataTable
                    paginator
                    rows={100}
                    rowsPerPageOptions={[100, 500, 1000]}
                    className="datatable-responsive custom-datatable"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                    emptyMessage="No customers found."
                    value={filteredBrands}
                    selection={selectedRow}
                    onSelectionChange={(e) => setselectedRow(e.value)}
                    sortMode="multiple"
                    loadingIcon="pi pi-spinner"
                    loading={loading}
                    loadingTemplate={<ClipLoader color={"#2C4870"} loading={loading} size={30} />}
                >
                    {!isClerk && <Column selectionMode="multiple" style={{ width: "3em" }} />}
                    <Column header="Action" body={actionBodyTemplate} />
                    <Column field="firstName" header="First Name" sortable />
                    <Column field="lastName" header="Last Name" sortable />
                    <Column field="email" header="Email" sortable />
                    <Column field="role" header="User Type" sortable />
                    <Column field="phone" header="Phone Number" sortable />
                    <Column header="Created On" field="date" />
                </DataTable>
            </div>
        </div>
    );
}

export default Customers;
